export const WHATSAPP_CHANNEL = 'whatsapp';
export const MESSENGER_CHANNEL = 'messenger';
export const CHAT_CHANNEL = 'chat';
export const TWILIO_CHANNEL = 'twilio';

export const CONVERSATION_CHANNELS = [
    WHATSAPP_CHANNEL,
    MESSENGER_CHANNEL,
    CHAT_CHANNEL,
];

export const INCOME_DIRECTION = 'income';
export const OUTCOME_DIRECTION = 'outcome';

export const API_TWILIO = 'twilio';
export const API_WSP = 'wsp';

export const CONVERSATION_DIRECTIONS = [INCOME_DIRECTION, OUTCOME_DIRECTION];

export const TWILIO_NAME = 'Twilio';
export const WSP_NAME = 'Whatsapp';

export type TConversationProvider = typeof API_TWILIO | typeof API_WSP;

export const ERROR_CODE_MESSAGE_UNDELIVERABLE = '131026';
export const ERROR_CODE_USER_NUMBER_IS_A_EXPERIMENT = '130472';
export const ERROR_CODE_REENGAGEMENT_MESSAGE = '131047';
export const ERROR_CODE_MESSAGE_LIMIT_MARKETING = '131049';

export const ERRORS_WHATSAPP_EXPLICATION = {
    [ERROR_CODE_MESSAGE_UNDELIVERABLE]: "Errors.WhatsApp.Undeliverable",
    [ERROR_CODE_USER_NUMBER_IS_A_EXPERIMENT]: "Errors.WhatsApp.UserNumberIsExperiment",
    [ERROR_CODE_REENGAGEMENT_MESSAGE]: "Errors.WhatsApp.ReengagementMessage",
    [ERROR_CODE_MESSAGE_LIMIT_MARKETING]: "Errors.WhatsApp.LimitMarketingMessage"
};

export const META_WSP_MESSAGE_STATUS_SENT = 'sent'
export const META_WSP_MESSAGE_STATUS_DELIVERED = 'delivered'
export const META_WSP_MESSAGE_STATUS_READ = 'read'
export const META_WSP_MESSAGE_STATUS_FAILED = 'failed'

export const COLOR_READ_MESSAGE = "#34b7f1";